import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';

import './SrSunSetupDriverJobPage.less';

const SrSunSetupDriverJobCodeboxCodes = ({ codeboxLock }) => {
  return (
    <div styleName="card" className="fieldsContainer">
      <span styleName="cardTitle">Codebox Codes</span>

      <SrBox margin="16px 0 0">
        <div styleName="jobDetailsBox">
          <span styleName="codeTitle">Master Code</span>
          <br />
          <span styleName={codeboxLock ? 'codeValue' : 'serialNumber'}>
            {codeboxLock?.masterCode || 'Register the Codebox to show'}
          </span>
        </div>
      </SrBox>

      <SrBox margin="16px 0 0">
        <div styleName="jobDetailsBox">
          <span styleName="codeTitle">Shackle Code</span>
          <br />
          <span styleName={codeboxLock ? 'codeValue' : 'serialNumber'}>
            {codeboxLock?.shackleCode || 'Register the Codebox to show'}
          </span>
        </div>
      </SrBox>
    </div>
  );
};

SrSunSetupDriverJobCodeboxCodes.propTypes = {
  codeboxLock: PropTypes.object,
};

SrSunSetupDriverJobCodeboxCodes.displayName = 'SrSunSetupDriverJobCodeboxCodes';

export default SrSunSetupDriverJobCodeboxCodes;
